import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { applyThemeVariables, readInitialDesignTheme } from './design/themeConfig';
import './index.css';
import './styles/corridor-theme.css';
import App from './App';
import ErrorBoundary from './components/ErrorBoundary';
import { BrandingConfigProvider } from './BrandingConfigContext';
import { DesignThemeProvider } from './design/DesignThemeContext';
import reportWebVitals from './reportWebVitals';

applyThemeVariables(readInitialDesignTheme(), null);

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <ErrorBoundary>
      <BrowserRouter>
        <BrandingConfigProvider>
          <DesignThemeProvider>
            <App />
          </DesignThemeProvider>
        </BrandingConfigProvider>
      </BrowserRouter>
    </ErrorBoundary>
  </React.StrictMode>,
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
